import {
    Insurance_BookInsurance as book
} from "./backend"
import i18n from '@/i18n'
const bookInsurance = async (id, key, voucher, users) => {
    const parseDate = (input) => {
        var parts = input.match(/(\d+)/g);
        return new Date(Date.UTC(parts[2], parts[1] - 1, parts[0]));
    }
    let usersWithDate = [];
    for (let i = 0; i < users.length; i++) {
        const parsedUser = {... users[i]}
        parsedUser.birthday = parseDate(parsedUser.birthday);
        usersWithDate.push(parsedUser);
    }
    try {
        let { data } = await book({
            cmd: {
                orderId: id,
                token: key,
                voucherID: voucher,
                users: usersWithDate
            }
        });
        return data;
    } catch {
        return {
            success: false,
            errors: [i18n.t('errors.generic-error-check-input')]
        }
    }

}

export default {
    bookInsurance
}